var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qy-group-dinner-index" },
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "card-header" },
                    [
                      _c("span", [_vm._v("团餐管理")]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增活动")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "活动列表", name: "table" } },
                [
                  _c("QyGroupDinnerTablePane", {
                    ref: "tablePane",
                    on: { edit: _vm.handleEdit, refresh: _vm.handleRefresh },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.activeTab === "config"
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "活动配置", name: "config" } },
                    [
                      _c("QyGroupDinnerConfigPane", {
                        attrs: { activityId: _vm.currentActivityId },
                        on: { save: _vm.handleSave, cancel: _vm.handleCancel },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }